/* eslint-disable max-len */
import { gql } from '@apollo/client';

export const GET_PROJECTS = gql`
  query Projects ($limit: Int, $offset: Int, $order: String, $name: String, $id: ID) {
    projects(limit: $limit, offset: $offset, order: $order, name: $name, id: $id) {
      id
      name
      surveysVersions {
        id
        version
      }
      segments {
        id
        name
      }
    }
  }
`;

export const LIMIT = 50;

export const GET_LIST_RATING = gql`
  query ManageAudience($limit: Int!, $offset: Int!, $companyId: ID!, $projectId: ID!, $screenerVersion: String!, $questionOrder: String, $segmentId: ID) {
    manageAudience(limit: $limit, offset: $offset, companyId: $companyId, projectId: $projectId, screenerVersion: $screenerVersion, questionOrder: $questionOrder, segmentId: $segmentId) {
      version
      questions(questionOrder: $questionOrder) {
        id
        label
        screenerRatingPercentage
        questionOptions {
          id
          label
          qualify
          disqualify
          optionRatingPercentage
        }
      }
    }
  }
`;

export const UPDATE_SCREENER_RATING_PERCENTAGE = gql`
  mutation UpdateScreenerRatingPercentage($questionId: ID!, $screenerRatingPercentage: Float!) {
    updateScreenerRatingPercentage(questionId: $questionId, screenerRatingPercentage: $screenerRatingPercentage) {
      question {
        id
        screenerRatingPercentage
      }
    }
  }
`;

export const UPDATE_OPTION_RATING_PERCENTAGE = gql`
  mutation UpdateOptionRatingPercentage($questionOptionId: ID!, $optionRatingPercentage: Float!) {
    updateOptionRatingPercentage(questionOptionId: $questionOptionId, optionRatingPercentage: $optionRatingPercentage) {
      questionOption {
        id
        optionRatingPercentage
      }
    }
  }
`;
